module.exports = __webpack_public_path__ + "static/media/manifesto.2b152bf0.png";